import axios from 'axios';

const publicApiClient = axios.create({
  baseURL: 'https://contest.new-waay.com/survey/questionnaires/',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

const authApiClient = axios.create({
  baseURL: 'https://contest.new-waay.com/survey/questionnaires/',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

// Function to handle token invalidation
const handleTokenInvalidation = () => {
  // Clear all auth-related data from localStorage
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  
  // Redirect to login page
  window.location.href = '/login';
};

authApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      throw new Error('No access token found');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

authApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Handle token invalidation
          if (error.response.data?.detail === 'Token has been invalidated') {
            handleTokenInvalidation();
          } else {
            // Regular unauthorized error
      localStorage.removeItem('access_token');
            window.location.href = '/login';
          }
          break;
        case 403:
          // Handle forbidden access
          console.error('Access forbidden');
          window.location.href = '/unauthorized';
          break;
        case 404:
          // Handle not found
          console.error('Resource not found');
          break;
        case 409:
          // Handle conflict
          console.error('Conflict occurred');
          break;
        case 429:
          // Handle rate limiting
          console.error('Too many requests');
          break;
        case 500:
          // Handle server error
          console.error('Server error occurred');
          break;
        default:
          console.error('An error occurred');
      }
    }
    return Promise.reject(error);
  }
);

export { publicApiClient, authApiClient };